<template>
  <div class="modern-phone-input control">
    <div class="modern-phone-input__group">
      <div class="modern-phone-input__code">
        +1
      </div>
      <b-input
          :value="innerValue"
          v-cleave="mask"
          placeholder="234-567-8910"
          custom-class="modern-phone-input__number"
          @focusin.native="onFocusIn"
          @focusout.native="onFocusOut"
          @paste.native.prevent="onPastePhone"
      />
    </div>

    <small v-show="numberInFocus" class="help counter">
      {{ value ? value.length : 0 }} / 10
    </small>
  </div>
</template>

<script>
export default {
  name: 'ModernPhoneInput',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      numberInFocus: false,
      innerValue: this.value,
      mask: {
        delimiters: ['-', '-', ''],
        blocks: [3, 3, 4],
        numericOnly: true,
        onValueChanged: this.onValueChange,
      },
    };
  },
  methods: {
    onValueChange(event) {
      this.$emit('input', event.target.rawValue);
    },
    onFocusIn() {
      this.numberInFocus = true;
    },
    onFocusOut() {
      this.numberInFocus = false;
    },
    onPastePhone(event) {
      const digits = event.clipboardData
        .getData('text')
        .replace(/\D/g, '');

      this.innerValue = digits.slice(-10);
    },
  },
  watch: {
    value(value) {
      this.innerValue = value;
    },
  },
};
</script>
